import { render, staticRenderFns } from "./UpcomingFixturesWidget.vue?vue&type=template&id=7c07ef89&scoped=true"
import script from "./UpcomingFixturesWidget.vue?vue&type=script&lang=js"
export * from "./UpcomingFixturesWidget.vue?vue&type=script&lang=js"
import style0 from "./UpcomingFixturesWidget.vue?vue&type=style&index=0&id=7c07ef89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07ef89",
  null
  
)

export default component.exports